<script setup lang="ts">
import CurseItem from './CurseItem.vue';
 </script>
<template>
    <div class="curse_list">
        <CurseItem v-for="curse, index in curses" :key="index" :curse="curse"></CurseItem>
    </div>
</template>

<script lang="ts">
export default {
    data() {
        return {
            curses: [
                {
                    name: 'Проклятие',
                    description: 'Обычное проклятие, вы получите инструкцию для проведения обряда',
                    type: 'h1',
                    price: 500
                },
                {
                    name: 'Ритуал',
                    description: 'Проведение ритуала на алтаре нашего мага',
                    type: 'h1',
                    price: 1000
                },
                {
                    name: 'Призыв к богам',
                    description: 'АЛЛАХ',
                    type: 'h1',
                    price: 3000
                }
            ]
        }
    },
    name: 'CurseList'
}
</script>

<style scoped>
.curse_list {
    display: flex;
    flex-wrap: wrap;
}
</style>